/**
 * Utilitaires pour le formatage des dates
 */

/**
 * Formate une date en évitant les décalages de fuseau horaire
 * @param {string} dateStr - Date au format ISO ou YYYY-MM-DD
 * @param {object} options - Options de formatage
 * @returns {string} Date formatée
 */
export const formatDate = (dateStr, options = {}) => {
  if (!dateStr) return '-'
  
  // Si la date ne contient pas d'heure, ajouter minuit UTC
  const dateToFormat = dateStr.includes('T') ? dateStr : dateStr + 'T00:00:00.000Z'
  
  const defaultOptions = {
    timeZone: 'UTC',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }
  
  const formatOptions = { ...defaultOptions, ...options }
  
  return new Date(dateToFormat).toLocaleDateString('fr-FR', formatOptions)
}

/**
 * Formate une date avec l'heure
 * @param {string} dateStr - Date au format ISO
 * @param {object} options - Options de formatage
 * @returns {string} Date et heure formatées
 */
export const formatDateTime = (dateStr, options = {}) => {
  if (!dateStr) return '-'
  
  const defaultOptions = {
    timeZone: 'UTC',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  }
  
  const formatOptions = { ...defaultOptions, ...options }
  
  return new Date(dateStr).toLocaleString('fr-FR', formatOptions)
}

/**
 * Formate une date pour l'affichage dans les inputs
 * @param {string} dateStr - Date au format ISO ou YYYY-MM-DD
 * @returns {string} Date au format YYYY-MM-DD
 */
export const formatDateForInput = (dateStr) => {
  if (!dateStr) return ''
  
  // Si la date ne contient pas d'heure, ajouter minuit UTC
  const dateToFormat = dateStr.includes('T') ? dateStr : dateStr + 'T00:00:00.000Z'
  
  const date = new Date(dateToFormat)
  const year = date.getUTCFullYear()
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  const day = String(date.getUTCDate()).padStart(2, '0')
  
  return `${year}-${month}-${day}`
}

/**
 * Convertit une date locale en UTC pour l'envoi au serveur
 * @param {string} localDateStr - Date au format YYYY-MM-DD (heure locale)
 * @returns {string} Date au format ISO UTC
 */
export const localDateToUTC = (localDateStr) => {
  if (!localDateStr) return null
  
  // Créer une date en UTC à partir de la date locale
  const date = new Date(localDateStr + 'T00:00:00.000Z')
  return date.toISOString()
}

export default {
  formatDate,
  formatDateTime,
  formatDateForInput,
  localDateToUTC
}
